import { useCallback, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { useFetch } from '@reveni-io/reveni-ui'

import { formatTime, getUserDisplayName, groupEventsByDay } from '@/common/components/HistoryDrawer/helpers'
import commonServices from '@/common/services/services'

const useHistory = ({ returnPortalId, fieldKeys, fieldKeyPrefix, show, objectId, formatEvent }) => {
  const { t, i18n } = useTranslation()
  const fieldKeysString = (fieldKeys || []).join(',') || undefined

  const { loading, error, data, fetchData } = useFetch(commonServices.getHistory, {
    doInitialRequest: false,
  })

  const getBaseParams = useCallback(() => {
    const params = { returnPortalId }
    if (fieldKeysString) params.fieldKeys = fieldKeysString
    if (fieldKeyPrefix) params.fieldKeyPrefix = fieldKeyPrefix
    if (objectId) params.objectId = objectId

    return params
  }, [returnPortalId, fieldKeysString, fieldKeyPrefix, objectId])

  useEffect(() => {
    if (!show) return

    fetchData(getBaseParams())
  }, [fetchData, show, getBaseParams])

  const goNext = () => {
    if (!data?.next) return

    fetchData({ ...getBaseParams(), cursor: data.next })
  }

  const goPrev = () => {
    if (!data?.previous) return

    fetchData({ ...getBaseParams(), cursor: data.previous })
  }

  const rawGroups = show ? groupEventsByDay(data?.results || [], t, i18n.language) : []

  const dayGroups = rawGroups.map(group => ({
    label: group.label,
    events: group.events.map(event => ({
      ...formatEvent(event, t),
      batchId: event.batch_id,
      time: formatTime(event.timestamp),
      userName: getUserDisplayName(event.user),
    })),
  }))

  return {
    dayGroups,
    loading,
    error: !!error,
    hasNext: !!data?.next,
    hasPrev: !!data?.previous,
    goNext,
    goPrev,
  }
}

export default useHistory
